module.exports = __webpack_public_path__ + "media/images/icon_login_03-cf0bb3e02201fb116ce1db1b6136a660.svg";